var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionDense(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 0C3.73333 0 0 3.73333 0 8.33333C0 12.9333 3.73333 16.6667 8.33333 16.6667C12.9333 16.6667 16.6667 12.9333 16.6667 8.33333C16.6667 3.73333 12.9333 0 8.33333 0ZM9.16667 14.1667H7.5V12.5H9.16667V14.1667ZM10.8917 7.70833L10.1417 8.475C9.54167 9.08333 9.16667 9.58333 9.16667 10.8333H7.5V10.4167C7.5 9.5 7.875 8.66667 8.475 8.05833L9.50833 7.00833C9.81667 6.70833 10 6.29167 10 5.83333C10 4.91667 9.25 4.16667 8.33333 4.16667C7.41667 4.16667 6.66667 4.91667 6.66667 5.83333H5C5 3.99167 6.49167 2.5 8.33333 2.5C10.175 2.5 11.6667 3.99167 11.6667 5.83333C11.6667 6.56667 11.3667 7.23333 10.8917 7.70833Z",
    fill: "#06077D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionDense);
export default __webpack_public_path__ + "static/media/question-dense.e379568f.svg";
export { ForwardRef as ReactComponent };